import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ReportPropertyDetailConstant } from '../../residential-property/residential-property-detail.constant';
import { ReportPropertyDetailService } from '../../residential-property/residential-property-detail.service';
import moment from 'moment';
import { OfficeReportPropertyDetailConstant } from '../../office-property-detail/office-report-property-details.constant';
import { TranslateService } from '@ngx-translate/core';
import { ReportTableDropdown } from 'src/app/reports/components/reports-lists/models/reports.model';
import { ReportService } from 'src/app/reports/services/report.service';
import { PropertyCategoryEnum } from '../../../propertyCategory.enum';
import { SharedService } from 'src/app/common/services/shared.service';

@Component({
  selector: 'app-property-transaction',
  templateUrl: './property-transaction.component.html',
  styleUrls: ['./property-transaction.component.scss']
})
export class PropertyTransactionComponent{
  @Output() isEmpatyCheck: any = new EventEmitter();
  @Input() propertyInfo: any;
  @Input() report_category = 'residential';

  propertyTransactionLoading = false;
  propertyTransactionData = [];
  propertyTransactionCount = 0;

  transactionPropertyColumns  = ReportPropertyDetailConstant.transactionPropertyColumns;
  actualCount: number = 0;
  auctionCount : number = 0;
  quoteCount : number = 0;
  transTypes:any[] = [];
  propertyCategory = PropertyCategoryEnum;
  transactionType: ReportTableDropdown = {
      label: "reports.transactionType",
      data: [{
        value: 'Actual',
        id: 'Actual'
      }, {
        value: 'Auction',
        id: 'Auction'
      }, {
        value: 'Quote',
        id: 'Quote'
      }],
      default: "Actual",
      maxSelect: 3,
      reportType: true
    }
  isFirstTime = true;
  resetPaginator: boolean = false;
  constructor(
    public reportPropertyDetailService: ReportPropertyDetailService,
    private translate : TranslateService,
    public reportService: ReportService,
    private sharedService: SharedService
  ){
    this.sharedService.language$.subscribe(lang => {
      if (lang && !this.isFirstTime) {
        this.getPropertyTransaction(this.transTypes.toString())
      }
    })
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.transTypes = this.transactionType.data.map(e=> {return e.id});
    this.getPropertyTransaction(this.transTypes.toString());
    this.isFirstTime = false;
  }

  ngOnInit(): void {
    this.transTypes = this.transactionType.data.map(e=> {return e.id});
    if(this.report_category == PropertyCategoryEnum.MultiStoryOffice || this.report_category == PropertyCategoryEnum.VillaHouse || this.report_category == PropertyCategoryEnum.RetailFbAndEntertainment || this.report_category == PropertyCategoryEnum.MultiStoryResidential){
      this.transactionPropertyColumns = OfficeReportPropertyDetailConstant.propertyTransactionColumn
    }
    this.getPropertyTransaction(this.transTypes.toString());
    this.isFirstTime = false;
  }

  getPropertyTransaction(type:string= "") {
    this.propertyTransactionLoading = true;
    let payloadType = "";
    if(this.report_category === this.propertyCategory.VillaHouse) payloadType = "villa_house"
    else if(this.report_category === this.propertyCategory.RetailFbAndEntertainment) payloadType = "retail"
    else if(this.report_category === this.propertyCategory.MultiStoryOffice) payloadType = "office"
    else if(this.report_category === this.propertyCategory.MultiStoryResidential) payloadType = "residential"    
    this.reportPropertyDetailService.getPropertyTransctionReport(this.reportPropertyDetailService.propertyTransactionPayload, payloadType, this.propertyInfo?.property_uid, type).subscribe(
      {
        next: (res: any) => {
          if (res.status === 200) {
            this.isEmpatyCheck.emit(true);
            this.propertyTransactionData = res.data.map((value: any) => {
              value['transaction_date']= value.transaction_date ? moment.utc(value.transaction_date).local().format('DD MMM YYYY') : null;
              if(this.report_category === this.propertyCategory.MultiStoryOffice || this.report_category === PropertyCategoryEnum.RetailFbAndEntertainment || this.report_category === PropertyCategoryEnum.VillaHouse || this.report_category === PropertyCategoryEnum.MultiStoryResidential) {
                value['value'] = this.reportType(value);
              }
              if((this.report_category === PropertyCategoryEnum.VillaHouse || this.report_category === PropertyCategoryEnum.MultiStoryOffice || this.report_category === PropertyCategoryEnum.RetailFbAndEntertainment || this.report_category === PropertyCategoryEnum.MultiStoryResidential ) && value.source_name){
                value['transaction_type'] = `${value.transaction_type} (${value.source_name})`
              }
              return value;
            })
            if(this.reportPropertyDetailService.propertyTransactionPayload.pageNumber == 0){
            this.propertyTransactionCount = res.count;
            this.actualCount = res.actual_count;
            this.auctionCount = res.auction_count
            this.quoteCount = res.quote_count
           }

          } else {
            this.isEmpatyCheck.emit(false);
            this.propertyTransactionData = [];
            this.propertyTransactionCount = 0;
            this.actualCount = 0;
            this.auctionCount = 0;
            this.quoteCount = 0;
          }
          this.propertyTransactionLoading = false;
        },
        error:()=>{
          this.isEmpatyCheck.emit(false);
          this.propertyTransactionLoading = false;
          this.propertyTransactionData = [];
          this.propertyTransactionCount = 0;
          this.actualCount = 0;
          this.auctionCount = 0;
          this.quoteCount = 0;
        }
      }
    )
  }

  reportType(value: any): string {
    let recordType = `<div class="reportType-value">${value.value ? this.reportService.numFormat(value.value): ''}</div>`;
    if (value?.prop_type_govt && value?.prop_type_estater && value?.prop_type_govt !== value?.prop_type_estater) {
      recordType += `<div class="reportType-land"><del>${this.translate.instant(value?.prop_type_govt)}</del><span class='reportType'>*${this.translate.instant(value?.prop_type_estater)}</span></div>`;
    } else if (value?.prop_type_govt) {
      recordType += `<div  class="reportType-land">${this.translate.instant(value?.prop_type_govt)}</div>`;
    } else if (value?.prop_type_estater) {
      recordType += `<div  class="reportType-land">${this.translate.instant(value?.prop_type_estater)}</div>`;
    }
    return recordType;
  }



  onPageEvent(e: any) {
    this.reportPropertyDetailService.propertyTransactionPayload.pageNumber = (e.pageSize * e.pageIndex);
    this.getPropertyTransaction(this.transTypes.toString());
  }

  sortData(event: any) {
    let sort = {
      column: event.active,
      order: event.direction
    }
    this.transTypes = event?.selectedOptions
    this.reportPropertyDetailService.propertyTransactionPayload.pageNumber = 0;
    this.reportPropertyDetailService.propertyTransactionPayload.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');
    this.getPropertyTransaction(this.transTypes.toString());
  }

  downloadExcel(event: any, type: string, key:any) {
    console.log(this.report_category);
    
    let report_category = this.report_category;
    if(this.report_category === PropertyCategoryEnum.MultiStoryResidential) report_category = "residential"
    else if(this.report_category === PropertyCategoryEnum.RetailFbAndEntertainment) report_category = "retail"
    else if(this.report_category === this.propertyCategory.MultiStoryOffice) report_category = "office"
    else if(this.report_category === this.propertyCategory.VillaHouse) report_category = "villa_house"
    this.reportPropertyDetailService.downloadRentalReport(type, report_category, this.propertyInfo?.property_uid, key);
  }
  selectionChange(value: any) {
    this.transTypes = value;
    this.reportPropertyDetailService.propertyTransactionPayload.pageNumber = 0;
    this.resetPaginator = false; // force change detection
    setTimeout(() => {
      this.resetPaginator = true;
    }, 0);
    this.getPropertyTransaction(this.transTypes.toString());
  }

}
